import './App.css';
import Footer from './components/footer';
import Header from './components/header';
import Careers from './pages/Careers';
import DomainExpertiseComponent from './pages/DomainExpertise';
import Home from './pages/Home';
import ServicesComponent from './pages/Services';

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route
            exact
            path={'/'}
            element={<Home />}
          />
          <Route
            exact
            path={'/expertise/:domain'}
            element={<DomainExpertiseComponent />}
          />
          <Route
            exact
            path={'/service/:id'}
            element={<ServicesComponent />}
          />
          <Route
            exact
            path={'/careers'}
            element={<Careers />}
          />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
